export const HANDLE_EVENT = "handle-event";
export const RESOLVE_EVENT = "resolve-event";
export const IGNORE_NEXT_EVENT = "ignore-next-event";
export const SET_UNSUBSCRIBE = "setUnsubscribe";
